import { createComponentStore } from '../../utils/createComponentStore';
import { DemoJson } from './Components/AceEditorPlaceholder';

const initData = () => ({
  request_type: 'POST',
  data_type: 'JSON',
  endpoint_url: '',
  body: '',
  headers: [],
  setupMode: 'MANUAL',
  curl: '',
});

const { getStore: getApiExportStore, defaultStore } = createComponentStore({
  type: 'api_export',
  endpoint: 'api-export',
  registryKey: 'api-export',
  initData,

  onLoadData: (rawData) => {
    const d = { ...initData(), ...rawData };
    if (!d.setupMode) d.setupMode = 'MANUAL';
    return d;
  },

  extraState: () => ({
    placeholders: [],
  }),

  extraActions: (set, get) => ({
    // Override setComponentData to inject DemoJson as default body when no componentData exists
    setComponentData: (component) => {
      const cd = component.componentData;
      const updates = {
        componentId: component.componentId,
      };
      if (component.type) updates.type = component.type;

      if (cd && cd.data != null) {
        const rawData = typeof cd.data === 'object' ? cd.data : {};
        const d = { ...initData(), ...rawData };
        if (!d.setupMode) d.setupMode = 'MANUAL';
        updates.data = d;
        updates.name = cd.name || '';
        updates.lastModified = cd.lastModified || '';
      } else if (cd) {
        const { name, lastModified, ...rest } = cd;
        const d = { ...initData(), ...rest };
        if (!d.setupMode) d.setupMode = 'MANUAL';
        updates.data = d;
        updates.name = name || '';
        updates.lastModified = lastModified || '';
      } else {
        updates.data = {
          ...initData(),
          body: DemoJson,
        };
        updates.name = '';
        updates.lastModified = '';
      }

      set(updates);
    },

    // Override getTemplate to include placeholders
    getTemplate: () => {
      const s = get();
      return {
        componentId: s.componentId,
        name: s.name,
        type: s.type,
        lastModified: s.lastModified,
        data: JSON.parse(JSON.stringify(s.data)),
        placeholders: [...s.placeholders],
      };
    },

    // ---- Backward-compat aliases ----
    setApiExportTemplate: (component) => get().setComponentData(component),
    setApiExportName: (name) => set({ name }),
    setApiExportBody: (body) => set({ data: { ...get().data, body } }),

    // ---- Field-level setters ----
    updateComponentData: (data) => {
      if (data && data.curl) {
        set({ data: { ...get().data, curl: data.curl, setupMode: data.setupMode } });
      }
    },

    setRequestType: (requestType) => set({ data: { ...get().data, request_type: requestType } }),
    setDataType: (dataType) => set({ data: { ...get().data, data_type: dataType } }),
    setEndPointUrl: (endPointUrl) => set({ data: { ...get().data, endpoint_url: endPointUrl } }),
    setPlaceholders: (placeholders) => set({ placeholders: [...placeholders] }),
    setSetupMode: (mode) => set({ data: { ...get().data, setupMode: mode } }),
    setCurl: (curl) => set({ data: { ...get().data, curl } }),
    setHeaders: (headers) => set({ data: { ...get().data, headers: [...headers] } }),
  }),
});

export { getApiExportStore };
export default defaultStore;
